import React from "react";
import data from "./data";

const Social = ({ className }) => {
  return (
    <div className={className}>
      <h4 className="font-extrabold text-[30px] lg:text-[36px] leading-[42px] lg:leading-[44px] xl:leading-[48px] text-white">
        Social Media <span className="text-[#FE61BD]">Links</span>
      </h4>
      <p className="font-medium text-[16px] lg:text-[18px] leading-[30px] text-[#ababab] mt-4 xl:mt-6 text-left">
        Easy way to find Brú Finance on different social media platforms
      </p>
      <div className="flex items-center justify-start gap-[15px] xl:gap-[25px] flex-wrap mt-6">
        {data?.SOCIAL?.map((obj, i) => {
          return (
            <div
              key={i}
              onClick={() => window.open(obj?.link, "_blank")}
              className=" size-[38px] lg:size-[40px] xl:size-[52px] p-auto cursor-pointer"
            >
              <img
                alt=""
                src={obj?.img}
                className="size-[38px] lg:size-[40px] xl:size-[52px]"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Social;
